<template>
  <v-container class="pa-0 px-2">
    <v-row>
      <v-col class="pa-2" cols="12" sm="12" md="4">
        <v-card
          outlined
          style="box-shadow: 0 0 0px 2px #d8dde6"
          class="p-card"
        >
          <v-card-text class="px-0 pt-0 pb-0">
            <v-row class="ma-0">
              <v-col class="px-0 pt-0 pb-0" cols="12">
                <v-toolbar flat  class="mr-0">
                  <v-toolbar-title class="mr-1">
                    <p class="text-title mb-0 mt-0" style="color: #4a4a4a">
                      Não iniciados
                      <br />
                      <small>{{ list.nao_iniciados.qtd_pagamentos }} PAGAMENTOS / {{ list.nao_iniciados.qtd_operadoras }} OPERADORAS</small>
                    </p>
                  </v-toolbar-title>
                  <v-toolbar-items class="mb-4 ml-2" width="20px">
                    <v-menu offset-y max-width="20%">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="px-0 py-0"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          icon
                        >
                          <v-icon
                            class="px-1 pt-0"
                            color="primary"
                            size="14px"
                            @click="openInfo = true"
                            >fa-info-circle</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-list class="px-3 pt-3 pb-0" outlined flat solo>
                        <p style="font-width: 24px">Pagamentos para recursos de glosas aguardando análise.</p>
                      </v-list>
                    </v-menu>
                  </v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-toolbar-items class="text-end mb-4 ml-0 mr-n2" width="20px">
                    <v-icon
                      class="pa-0"
                      color="primary"
                      size="20px"
                      @click="setFilter('40')"
                      >fas fa-external-link-alt</v-icon>
                  </v-toolbar-items>
                </v-toolbar>
              </v-col>
            </v-row>
            <v-row class="pt-4">
                <v-col class="text-center" cols="4">
                  <b style="font-size:13px; color:#D0021B">{{ list.nao_iniciados.dados.qtd_pagamentos_acima_prazo }}</b><span class="title-text pb-1 ml-1">({{list.nao_iniciados.dados.porc_pagamentos_acima_prazo == 100 ?100 :(list.nao_iniciados.dados.porc_pagamentos_acima_prazo).toFixed(2).replace('.',',')}}%)</span>
                  <!-- <v-icon
                      class="pa-0 ml-1"
                      color="primary"
                      size="15px"
                      @click="setFilter('40', 'acima')"
                      >fas fa-external-link-alt</v-icon> -->
                  <div class="text-legend pb-1" style="color:#D0021B">ACIMA DO PRAZO</div>
                  <b style="font-size:13px; color:#D0021B">{{ list.nao_iniciados.dados.valor_calculado_acima_prazo | formatPrice }}</b><br><span class="title-text pb-1 ml-1">({{list.nao_iniciados.dados.porc_valor_calculado_acima_prazo == 100 ?100 :(list.nao_iniciados.dados.porc_valor_calculado_acima_prazo).toFixed(2).replace('.',',')}}%)</span>
                  <div class="text-legend pb-1">VALOR CALCULADO</div>
                </v-col>
                <v-col class="text-center" cols="4">
                  <b style="font-size:13px;color:#fc9e0d">{{ list.nao_iniciados.dados.qtd_pagamentos_criticos }}</b><span class="title-text pb-1 ml-1">({{list.nao_iniciados.dados.porc_pagamentos_criticos == 100 ?100 :(list.nao_iniciados.dados.porc_pagamentos_criticos).toFixed(2).replace('.',',')}}%)</span>
                  <!-- <v-icon
                      class="pa-0 ml-1"
                      color="primary"
                      size="15px"
                      @click="setFilter('40', 'critico')"
                      >fas fa-external-link-alt</v-icon> -->
                  <div class="text-legend pb-1" style="color:#fc9e0d">COM PRAZO CRÍTICO</div>
                  <b style="font-size:13px;color:#fc9e0d">{{ list.nao_iniciados.dados.valor_calculado_criticos | formatPrice }}</b><br><span class="title-text pb-1 ml-1">({{list.nao_iniciados.dados.porc_valor_calculado_criticos == 100 ?100 :(list.nao_iniciados.dados.porc_valor_calculado_criticos).toFixed(2).replace('.',',')}}%)</span>
                  <div class="text-legend  pb-1">VALOR CALCULADO</div>
                </v-col>
                <v-col class="text-center" cols="4">
                  <b style="font-size:13px;">{{ list.nao_iniciados.dados.qtd_pagamentos_dentro_prazo }}</b><span class="title-text pb-1 ml-1">({{list.nao_iniciados.dados.porc_pagamentos_dentro_prazo == 100 ?100 :(list.nao_iniciados.dados.porc_pagamentos_dentro_prazo).toFixed(2).replace('.',',')}}%)</span>
                  <!-- <v-icon
                      class="pa-0 ml-1"
                      color="primary"
                      size="15px"
                      @click="setFilter('40', 'noprazo')"
                      >fas fa-external-link-alt</v-icon> -->
                  <div class="text-legend pb-1">DENTRO DO PRAZO</div>
                  <b style="font-size:13px;">{{ list.nao_iniciados.dados.valor_calculado_dentro_prazo | formatPrice }}</b><br><span class="title-text pb-1 ml-1">({{list.nao_iniciados.dados.porc_valor_calculado_dentro_prazo == 100 ?100 :(list.nao_iniciados.dados.porc_valor_calculado_dentro_prazo).toFixed(2).replace('.',',')}}%)</span>
                  <div class="text-legend pb-1">
                    VALOR CALCULADO
                  </div>
                </v-col>
                <v-col class="text-center px-0 pb-0" cols="12">
                <div class="value-text">{{ list.nao_iniciados.valor_total | formatPrice }}</div>
                <p>TOTAL GLOSADO</p>
              </v-col>
              </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="pa-2" cols="12" sm="12" md="4">
        <v-card
          outlined
          style="box-shadow: 0 0 0px 2px #FC9D0A"
          class="p-card"
        >
          <v-card-text class="px-0 pt-0 pb-0">
            <v-row class="ma-0">
              <v-col class="px-0 pt-0 pb-0" cols="12">
                <v-toolbar flat>
                  <v-toolbar-title class="mr-1">
                    <p class="text-title mb-0 mt-0" style="color: #FC9D0A">
                      Em análise
                      <br />
                      <small>{{ list.em_analise.qtd_pagamentos }} PAGAMENTOS / {{ list.em_analise.qtd_operadoras }} OPERADORAS</small>
                    </p>
                  </v-toolbar-title>
                  <v-toolbar-items class="mb-4 ml-2" width="20px">
                    <v-menu offset-y max-width="20%">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="px-0 py-0"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          icon
                        >
                          <v-icon
                            class="px-1 pt-0"
                            color="primary"
                            size="14px"
                            @click="openInfo = true"
                            >fa-info-circle</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-list class="px-3 pt-3 pb-0" outlined flat solo>
                        <p style="font-width: 24px">
                          Pagamentos de recursos de glosa em analise pelo analista.
                        </p>
                      </v-list>
                    </v-menu>
                  </v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-toolbar-items class="text-end mb-4 ml-0 mr-n2" width="20px">
                    <v-icon
                      class="pa-0"
                      color="primary"
                      size="20px"
                      @click="setFilter('50')"
                      >fas fa-external-link-alt</v-icon>
                      <!-- @click="filter('Critica')" -->
                  </v-toolbar-items>
                </v-toolbar>
              </v-col>
            </v-row>
            <v-row class="pt-4">
                <v-col class="text-center" cols="4">
                  <b style="font-size:13px; color:#D0021B">{{ list.em_analise.dados.qtd_pagamentos_acima_prazo }}</b><span class="title-text pb-1 ml-1">({{list.em_analise.dados.porc_pagamentos_acima_prazo == 100 ?100 :(list.em_analise.dados.porc_pagamentos_acima_prazo).toFixed(2).replace('.',',')}}%)</span>
                  <!-- <v-icon
                      class="pa-0 ml-1"
                      color="primary"
                      size="15px"
                      @click="setFilter('50', 'acima')"
                      >fas fa-external-link-alt</v-icon> -->
                  <div class="text-legend pb-1" style="color:#D0021B">ACIMA DO PRAZO</div>
                  <b style="font-size:13px; color:#D0021B">{{ list.em_analise.dados.valor_calculado_acima_prazo | formatPrice }}</b><br><span class="title-text pb-1 ml-1">({{list.em_analise.dados.porc_valor_calculado_acima_prazo == 100 ?100 :(list.em_analise.dados.porc_valor_calculado_acima_prazo).toFixed(2).replace('.',',')}}%)</span>
                  <div class="text-legend pb-1">VALOR CALCULADO</div>
                </v-col>
                <v-col class="text-center" cols="4">
                  <b style="font-size:13px;color:#fc9e0d">{{ list.em_analise.dados.qtd_pagamentos_criticos }}</b><span class="title-text pb-1 ml-1">({{list.em_analise.dados.porc_pagamentos_criticos == 100 ?100 :(list.em_analise.dados.porc_pagamentos_criticos).toFixed(2).replace('.',',')}}%)</span>
                  <!-- <v-icon
                      class="pa-0 ml-1"
                      color="primary"
                      size="15px"
                      @click="setFilter('50', 'critico')"
                      >fas fa-external-link-alt</v-icon> -->
                  <div class="text-legend pb-1" style="color:#fc9e0d">COM PRAZO CRÍTICO</div>
                  <b style="font-size:13px;color:#fc9e0d">{{ list.em_analise.dados.valor_calculado_criticos | formatPrice }}</b><br><span class="title-text pb-1 ml-1">({{list.em_analise.dados.porc_valor_calculado_criticos == 100 ?100 :(list.em_analise.dados.porc_valor_calculado_criticos).toFixed(2).replace('.',',')}}%)</span>
                  <div class="text-legend pb-1">VALOR CALCULADO</div>
                </v-col>
                <v-col class="text-center" cols="4">
                  <b style="font-size:13px;">{{ list.em_analise.dados.qtd_pagamentos_dentro_prazo }}</b><span class="title-text pb-1 ml-1">({{list.em_analise.dados.porc_pagamentos_dentro_prazo == 100 ?100 :(list.em_analise.dados.porc_pagamentos_dentro_prazo).toFixed(2).replace('.',',')}}%)</span>
                  <!-- <v-icon
                      class="pa-0 ml-1"
                      color="primary"
                      size="15px"
                      @click="setFilter('50', 'noprazo')"
                      >fas fa-external-link-alt</v-icon> -->
                  <div class="text-legend pb-1">DENTRO DO PRAZO</div>
                  <b style="font-size:13px;">{{ list.em_analise.dados.valor_calculado_dentro_prazo | formatPrice }}</b><br><span class="title-text pb-1 ml-1">({{list.em_analise.dados.porc_valor_calculado_dentro_prazo == 100 ?100 :(list.em_analise.dados.porc_valor_calculado_dentro_prazo).toFixed(2).replace('.',',')}}%)</span>
                  <div class="text-legend pb-1">
                    VALOR CALCULADO
                  </div>
                </v-col>
                <v-col class="text-center px-0 pb-0" cols="12">
                <div class="value-text">{{ list.em_analise.valor_total | formatPrice }}</div>
                <p>TOTAL GLOSADO</p>
              </v-col>
              </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- PRONTO PRA ENVIO -->
      <v-col class="pa-2" cols="12" sm="12" md="4">

        <v-card
          outlined
          style="box-shadow: 0 0 0px 2px #FC5F17;"
          class="p-card"
        >
          <v-card-text class="px-0 pt-0 pb-0">
            <v-row class="ma-0">
              <v-col class="px-0 pt-0 pb-0" cols="12">
                <v-toolbar flat>
                  <v-toolbar-title class="mr-1">
                    <p class="text-title mb-0 mt-0" style="color: #FC5F17">
                      Pronto para transmitir
                      <br />
                      <small>{{ list.pronto_envio.qtd_pagamentos }} PAGAMENTOS / {{ list.pronto_envio.qtd_operadoras }} OPERADORAS</small>
                    </p>
                  </v-toolbar-title>
                  <v-toolbar-items class="mb-4 ml-2" width="20px">
                    <v-menu offset-y max-width="20%">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="px-0 py-0"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          icon
                        >
                          <v-icon
                            class="px-1 pt-0"
                            color="primary"
                            size="14px"
                            >fa-info-circle</v-icon
                          >
                            <!-- @click="openInfo = true" -->
                        </v-btn>
                      </template>
                      <v-list class="px-3 pt-3 pb-0" outlined flat solo>
                        <p style="font-width: 24px">
                         Arquivos gerados prontos para envio manual através do portal da operadora.
                        </p>
                      </v-list>
                    </v-menu>
                  </v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-toolbar-items class="text-end mb-4 ml-0 mr-n2" width="20px">
                    <v-icon
                      class="pa-0"
                      color="primary"
                      size="20px"
                      @click="setFilter('60')"
                      >fas fa-external-link-alt</v-icon
                    >
                      <!-- @click="filter('AEnvio')" -->
                  </v-toolbar-items>
                </v-toolbar>
              </v-col>

              <!-- <v-col class="text-center px-5 py-0" cols="6"> -->
                <v-row>
                  <v-col class="text-center pa-0" style="line-height:15px" cols="12">
                    <b class="title-text">ENVIO MANUAL</b>
                  </v-col>
                  <v-col class="text-center" cols="6">
                  <b style="font-size:13px;color:#fc9e0d">{{ list.pronto_envio.dados.qtd_pagamentos_criticos }}</b><span class="title-text pb-1 ml-1">({{list.pronto_envio.dados.porc_pagamentos_criticos == 100 ?100 :(list.pronto_envio.dados.porc_pagamentos_criticos).toFixed(2).replace('.',',')}}%)</span>
                  <div class="text-legend pb-1" style="color:#fc9e0d">COM PRAZO CRÍTICO</div>
                  <b style="font-size:13px;color:#fc9e0d">{{ list.pronto_envio.dados.valor_calculado_criticos | formatPrice }}</b><br><span class="title-text pb-1 ml-1">({{list.pronto_envio.dados.porc_valor_calculado_criticos == 100 ?100 :(list.pronto_envio.dados.porc_valor_calculado_criticos).toFixed(2).replace('.',',')}}%)</span>
                  <div class="text-legend  pb-1">VALOR CALCULADO</div>
                </v-col>
                <v-col class="text-center" cols="6">
                  <b style="font-size:13px;">{{ list.pronto_envio.dados.qtd_pagamentos_dentro_prazo }}</b><span class="title-text pb-1 ml-1">({{list.pronto_envio.dados.porc_pagamentos_dentro_prazo == 100 ?100 :(list.pronto_envio.dados.porc_pagamentos_dentro_prazo).toFixed(2).replace('.',',')}}%)</span>
                  <div class="text-legend pb-1">DENTRO DO PRAZO</div>
                  <b style="font-size:13px;">{{ list.pronto_envio.dados.valor_calculado_dentro_prazo | formatPrice }}</b><br><span class="title-text pb-1 ml-1">({{list.pronto_envio.dados.porc_valor_calculado_dentro_prazo == 100 ?100 :(list.pronto_envio.dados.porc_valor_calculado_dentro_prazo).toFixed(2).replace('.',',')}}%)</span>
                  <div class="text-legend pb-1">
                    VALOR CALCULADO
                  </div>
                </v-col>
                </v-row>
              <!-- </v-col> -->

              <v-col class="text-center px-0 pb-0" cols="12">
                <div class="value-text">{{ list.pronto_envio.valor_total | formatPrice }}</div>
                <p>VALOR CALCULADO</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- EM TRANSMISSÃO -->
      <v-col class="pa-2" cols="12" sm="12" md="6">

        <v-card
          outlined
          style="box-shadow: 0 0 0px 2px #B2B842;"
          class="p-card"
        >
          <v-card-text class="px-0 pt-0 pb-0">
            <v-row class="ma-0">
              <v-col class="px-0 pt-0 pb-0" cols="12">
                <v-toolbar flat>
                  <v-toolbar-title class="mr-1">
                    <p class="text-title mb-0 mt-0" style="color: #B2B842">
                      Em transmissão
                      <br />
                      <small>{{ list.em_transmissao.qtd_pagamentos }} PAGAMENTOS / {{ list.em_transmissao.qtd_operadoras }} OPERADORAS</small>
                    </p>
                  </v-toolbar-title>
                  <v-toolbar-items class="mb-4 ml-2" width="20px">
                    <v-menu offset-y max-width="20%">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="px-0 py-0"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          icon
                        >
                          <v-icon
                            class="px-1 pt-0"
                            color="primary"
                            size="14px"
                            >fa-info-circle</v-icon
                          >
                            <!-- @click="openInfo = true" -->
                        </v-btn>
                      </template>
                      <v-list class="px-3 pt-3 pb-0" outlined flat solo>
                        <p style="font-width: 24px">
                          Pagamento de recurso de glosa sendo enviado para operadora.
                        </p>
                      </v-list>
                    </v-menu>
                  </v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-toolbar-items class="text-end mb-4 ml-0 mr-n2" width="20px">
                    <v-icon
                      class="pa-0"
                      color="primary"
                      size="20px"
                      @click="setFilter('70')"
                      >fas fa-external-link-alt</v-icon
                    >
                      <!-- @click="filter('AEnvio')" -->
                  </v-toolbar-items>
                </v-toolbar>
              </v-col>
              <v-col class="text-center px-2 py-0" cols="6">
                <v-row>
                  <v-col class="text-center pa-0" cols="12">
                    <b class="title-text">ENVIO AUTOMÁTICO</b>
                  </v-col>
                  <v-col class="text-center" cols="6">
                  <b style="font-size:13px;color:#fc9e0d">{{ list.em_transmissao.automatico.qtd_pagamentos_criticos }}</b><br><span class="title-text pb-1 ml-1">({{list.em_transmissao.automatico.porc_pagamentos_criticos == 100 ?100 :(list.em_transmissao.automatico.porc_pagamentos_criticos).toFixed(2).replace('.',',')}}%)</span>
                  <div class="text-legend pb-1" style="color:#fc9e0d">COM PRAZO CRÍTICO</div>
                  <b style="font-size:13px;color:#fc9e0d">{{ list.em_transmissao.automatico.valor_calculado_criticos | formatPrice }}</b><br><span class="title-text pb-1 ml-1">({{list.em_transmissao.automatico.porc_valor_calculado_criticos == 100 ?100 :(list.em_transmissao.automatico.porc_valor_calculado_criticos).toFixed(2).replace('.',',')}}%)</span>
                  <div class="text-legend  pb-1">VALOR CALCULADO</div>
                </v-col>
                <v-col class="text-center" cols="6">
                  <b style="font-size:13px;">{{ list.em_transmissao.automatico.qtd_pagamentos_dentro_prazo }}</b><br><span class="title-text pb-1 ml-1">({{list.em_transmissao.automatico.porc_pagamentos_dentro_prazo == 100 ?100 :(list.em_transmissao.automatico.porc_pagamentos_dentro_prazo).toFixed(2).replace('.',',')}}%)</span>
                  <div class="text-legend pb-1">DENTRO DO PRAZO</div>
                  <b style="font-size:13px;">{{ list.em_transmissao.automatico.valor_calculado_dentro_prazo | formatPrice }}</b><br><span class="title-text pb-1 ml-1">({{list.em_transmissao.automatico.porc_valor_calculado_dentro_prazo == 100 ?100 :(list.em_transmissao.automatico.porc_valor_calculado_dentro_prazo).toFixed(2).replace('.',',')}}%)</span>
                  <div class="text-legend pb-1">
                    VALOR CALCULADO
                  </div>
                </v-col>
                </v-row>
              </v-col>

              <v-col class="text-center px-2 py-0" cols="6">
                <v-row>
                  <v-col class="text-center pa-0" cols="12">
                    <b class="title-text">ENVIO MANUAL</b>
                  </v-col>
                  <v-col class="text-center" cols="6">
                  <b style="font-size:13px;color:#fc9e0d">{{ list.em_transmissao.manual.qtd_pagamentos_criticos }}</b><br><span class="title-text pb-1 ml-1">({{list.em_transmissao.manual.porc_pagamentos_criticos == 100 ?100 :(list.em_transmissao.manual.porc_pagamentos_criticos).toFixed(2).replace('.',',')}}%)</span>
                  <div class="text-legend pb-1" style="color:#fc9e0d">COM PRAZO CRÍTICO</div>
                  <b style="font-size:13px;color:#fc9e0d">{{ list.em_transmissao.manual.valor_calculado_criticos | formatPrice }}</b><br><span class="title-text pb-1 ml-1">({{list.em_transmissao.manual.porc_valor_calculado_criticos == 100 ?100 :(list.em_transmissao.manual.porc_valor_calculado_criticos).toFixed(2).replace('.',',')}}%)</span>
                  <div class="text-legend  pb-1">VALOR CALCULADO</div>
                </v-col>
                <v-col class="text-center" cols="6">
                  <b style="font-size:13px;">{{ list.em_transmissao.manual.qtd_pagamentos_dentro_prazo }}</b><br><span class="title-text pb-1 ml-1">({{list.em_transmissao.manual.porc_pagamentos_dentro_prazo == 100 ?100 :(list.em_transmissao.manual.porc_pagamentos_dentro_prazo).toFixed(2).replace('.',',')}}%)</span>
                  <div class="text-legend pb-1">DENTRO DO PRAZO</div>
                  <b style="font-size:13px;">{{ list.em_transmissao.manual.valor_calculado_dentro_prazo | formatPrice }}</b><br><span class="title-text pb-1 ml-1">({{list.em_transmissao.manual.porc_valor_calculado_dentro_prazo == 100 ?100 :(list.em_transmissao.manual.porc_valor_calculado_dentro_prazo).toFixed(2).replace('.',',')}}%)</span>
                  <div class="text-legend pb-1">
                    VALOR CALCULADO
                  </div>
                </v-col>
                </v-row>
              </v-col>

              <v-col class="text-center px-0 pb-0 pt-1" cols="12">
                <div class="value-text">{{ list.em_transmissao.valor_total | formatPrice }}</div>
                <p>VALOR CALCULADO</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- ENVIADOS -->
      <v-col class="pa-2" cols="12" sm="12" md="3">

        <v-card
          outlined
          style="box-shadow: 0 0 0px 2px #d8dde6;"
          class="p-card"
        >
          <v-card-text class="px-0 pt-0 pb-0">
            <v-row class="ma-0">
              <v-col class="px-0 pt-0 pb-0" cols="12">
                <v-toolbar flat>
                  <v-toolbar-title class="mr-1">
                    <p class="text-title mb-0 mt-0" style="color: #4a4a4a">
                      Transmitidos
                      <br />
                      <small>{{ list.transmitidos.qtd_pagamentos }} PAGAMENTOS / {{ list.transmitidos.qtd_operadoras }} OPERADORAS</small>
                    </p>
                  </v-toolbar-title>
                  <v-toolbar-items class="mb-4 ml-2" width="20px">
                    <v-menu offset-y max-width="20%">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="px-0 py-0"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          icon
                        >
                          <v-icon
                            class="px-1 pt-0"
                            color="primary"
                            size="14px"
                            >fa-info-circle</v-icon
                          >
                            <!-- @click="openInfo = true" -->
                        </v-btn>
                      </template>
                      <v-list class="px-3 pt-3 pb-0" outlined flat solo>
                        <p style="font-width: 24px">
                         Arquivos enviados automaticamente à operadora.
                        </p>
                      </v-list>
                    </v-menu>
                  </v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-toolbar-items class="text-end mb-4 ml-0 mr-n2" width="20px">
                    <!-- <v-icon
                      class="pa-0"
                      color="primary"
                      size="20px"
                      @click="setFilter('60')"
                      >fas fa-external-link-alt</v-icon
                    > -->
                  </v-toolbar-items>
                </v-toolbar>
              </v-col>

              <!-- <v-col class="text-center px-5 py-0" cols="6"> -->
                <v-row>
                  <v-col class="text-center pa-0" style="min-height: 18px" cols="12">
                    <!-- <b class="title-text">ENVIO AUTOMÁTICO</b> -->
                  </v-col>
                  <v-col class="text-center pt-1" cols="6">
                  <b style="font-size:13px;color:#118ACA">{{list.transmitidos.qtd_enviado}}</b><br><span class="title-text pb-1 ml-1">({{list.transmitidos.porc_enviado.toFixed(2).replace('.', ',') }}%)</span>
                  <v-icon
                      small
                      class="pa-0 ml-2 mb-2"
                      color="primary"
                      size="20px"
                      @click="setFilter('75')"
                      >fas fa-external-link-alt</v-icon
                    >
                  <div class="text-legend pb-1" style="color:#118ACA">RECURSOS ENVIADOS</div>
                  <b style="font-size:13px;color:#118ACA">{{ list.transmitidos.valor_enviado | formatPrice }}</b><br><span class="title-text pb-1 ml-1">({{list.transmitidos.porc_enviado.toFixed(2).replace('.', ',')}}%)</span>
                  <div class="text-legend pt-1 pb-1">
                    VALOR CALCULADO
                  </div>
                </v-col>
                <v-col class="text-center pt-1" cols="6">
                  <b style="font-size:13px;color:#9154CD">{{list.transmitidos.qtd_aconcluir}}</b><br><span class="title-text pb-1 ml-1">({{list.transmitidos.porc_aconcluir.toFixed(2).replace('.', ',') }}%)</span>
                   <v-icon
                      small
                      class="pa-0 ml-2 mb-2"
                      color="primary"
                      size="20px"
                      @click="setFilter('98')"
                      >fas fa-external-link-alt</v-icon
                    >
                  <div class="text-legend pb-1"  style="color:#9154CD">AGUARD. CONCLUSÃO</div>
                  <b style="font-size:13px; color:#9154CD">{{list.transmitidos.valor_aconcluir | formatPrice }}</b><br><span class="title-text pb-1 ml-1">({{list.transmitidos.porc_valor_aconcluir.toFixed(2).replace('.', ',')}}%)</span>
                  <div class="text-legend pt-1 pb-0">
                    VALOR CALCULADO
                  </div>
                </v-col>
                </v-row>
              <!-- </v-col> -->

              <v-col class="text-center px-0 pb-0 pt-1" cols="12">
                <div class="value-text">{{ list.transmitidos.valor_total | formatPrice }}</div>
                <p>VALOR CALCULADO</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- COM CRÍTICA -->
      <v-col class="pa-2" cols="12" sm="12" md="3">
        <v-card
          outlined
          style="box-shadow: 0 0 0px 2px #d0021b;"
          class="p-card"
        >
          <v-card-text class="px-0 pt-0 pb-0">
            <v-row class="ma-0">
              <v-col class="px-0 pt-0 pb-0" cols="12">
                <v-toolbar flat>
                  <v-toolbar-title class="mr-1">
                    <p class="text-title mb-0 mt-0" style="color: #d0021b">
                      Com crítica
                      <br />
                      <small>{{ list.com_critica.qtd_pagamentos }} PAGAMENTOS / {{ list.com_critica.qtd_operadoras }} OPERADORAS</small>
                    </p>
                  </v-toolbar-title>
                  <v-toolbar-items class="mb-4 ml-2" width="20px">
                    <v-menu offset-y max-width="20%">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="px-0 py-0"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          icon
                        >
                          <v-icon
                            class="px-1 pt-0"
                            color="primary"
                            size="14px"
                            @click="openInfo = true"
                            >fa-info-circle</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-list class="px-3 pt-3 pb-0" outlined flat solo>
                        <p style="font-width: 24px">Recursos de glosas criticados pela operadora (requer analise).</p>
                      </v-list>
                    </v-menu>
                  </v-toolbar-items>
                  <v-spacer></v-spacer>
                  <v-toolbar-items class="text-end mb-4 ml-0 mr-n2" width="20px">
                    <v-icon
                      class="pa-0"
                      color="primary"
                      size="20px"
                      @click="setFilter('80')"
                      >fas fa-external-link-alt</v-icon>
                      <!-- to="/recebiveis/recursosdeglosa" -->
                      <!-- @click="filter('Critica')" -->
                  </v-toolbar-items>
                </v-toolbar>
              </v-col>
              <v-col class="text-center pa-0" style="min-height: 22px" cols="12">
                    <!-- <b class="title-text">ENVIO AUTOMÁTICO</b> -->
                  </v-col>
              <v-col class="text-center pt-0" cols="6">
                  <b style="font-size:13px;color:#fc9e0d">{{ list.com_critica.dados.qtd_pagamentos_criticos }}</b><br><span class="title-text pb-1 ml-1">({{list.com_critica.dados.porc_pagamentos_criticos == 100 ?100 :(list.com_critica.dados.porc_pagamentos_criticos).toFixed(2)}}%)</span>
                  <div class="text-legend pt-1 pb-1" style="color:#fc9e0d">COM PRAZO CRÍTICO</div>
                  <b style="font-size:13px; color:#fc9e0d">{{ list.com_critica.dados.valor_calculado_criticos | formatPrice }}</b><br><span class="title-text pb-1 ml-1">({{list.com_critica.dados.porc_valor_calculado_criticos == 100 ?100 :(list.com_critica.dados.porc_valor_calculado_criticos).toFixed(2)}}%)</span>
                  <div class="text-legend  pt-1 pb-1">VALOR CALCULADO</div>
                </v-col>
                <v-col class="text-center pt-0" cols="6">
                  <b style="font-size:13px;">{{ list.com_critica.dados.qtd_pagamentos_dentro_prazo }}</b><br><span class="title-text pb-1 ml-1">({{list.com_critica.dados.porc_pagamentos_dentro_prazo == 100 ?100 :(list.com_critica.dados.porc_pagamentos_dentro_prazo).toFixed(2)}}%)</span>
                  <div class="text-legend pt-1 pb-1">DENTRO DO PRAZO</div>
                  <b style="font-size:13px;">{{ list.com_critica.dados.valor_calculado_dentro_prazo | formatPrice }}</b><br><span class="title-text pb-1 ml-1">({{list.com_critica.dados.porc_valor_calculado_dentro_prazo == 100 ?100 :(list.com_critica.dados.porc_valor_calculado_dentro_prazo).toFixed(2).replace('.',',')}}%)</span>
                  <div class="text-legend pt-1 pb-1">
                    VALOR CALCULADO
                  </div>
                </v-col>
              <v-col class="text-center px-0 pb-0 pt-1" cols="12">
                <div class="value-text">{{ list.com_critica.valor_total | formatPrice }}</div>
                <p>VALOR DOS RECURSOS</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      
      <!-- <v-col class="pa-2" cols="12" sm="12" md="4">
        <v-card
          max-width="400px"
          height="140px"
          outlined
          style="box-shadow: 0 0 0px 2px #32b88b"
          class="p-card"
        >
          <v-card-text class="px-0 pt-2 pb-0">
            <v-row class="ma-0">
              <v-col class="px-0 pt-1 pb-0" cols="12">
                <v-toolbar color="rgba(0,0,0,0)" flat>
                  <v-toolbar-title class="mr-1">
                    <p class="text-title mb-0 mt-0" style="color: #32b88b">
                      Concluídos em {{monthYear}}
                      <br />
                      <small
                        >{{ list.qt_crono_processamento_manual }} PAGAMENTOS / 3 OPERADORAS</small>
                    </p>
                  </v-toolbar-title>
                  <v-toolbar-items class="mb-4 ml-2" width="20px">
                    <v-menu offset-y max-width="20%">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="px-0 py-0"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          icon
                        >
                          <v-icon
                            class="px-1 pt-0"
                            color="primary"
                            size="14px"
                            @click="openInfo = true"
                            >fa-info-circle</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-list class="px-3 pt-3 pb-0" outlined flat solo>
                        <p style="font-width: 24px">
                          Lotes em processamento, sendo validação Tiss e lotes
                          em transmissão para operadora.
                        </p>
                      </v-list>
                    </v-menu>
                  </v-toolbar-items>
                  <v-spacer></v-spacer>
                </v-toolbar>
                
              </v-col>
              <v-col class="text-center px-0 pb-0 pt-1" cols="6">
                <div class="value-text">{{list.vl_crono_concluido_previsto | formatPrice}}</div>
                <p>VALOR RECURSADO</p>
              </v-col>
              <v-col class="text-center px-0 pb-0 pt-1" cols="6">
                <div class="value-text">{{list.vl_crono_concluido_previsto | formatPrice}}</div>
                <p>VALOR ACATADO</p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
export default {
  filters: {
    formatPrice(value) {
        // if(!value) return ''
        let val = (value/1).toFixed(2).replace('.', ',')
        return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
  props: {
    filter: Function,
    list: Object,
    monthYear: String,
    parameters: Object,
    setFilter: Function
  },
};
</script>

